// Custom Variant Dropdown Logic
// Handles opening, closing, and selecting options for the custom variant dropdown

document.addEventListener('DOMContentLoaded', function () {
  function closeAllDropdowns(except) {
    document.querySelectorAll('.custom-variant-dropdown').forEach(function (dropdown) {
      const list = dropdown.querySelector('[data-dropdown-list]');
      if (dropdown !== except) {
        list.setAttribute('hidden', '');
        dropdown.classList.remove('open');
      }
    });
  }

  function setupDropdown(dropdown) {
    const selected = dropdown.querySelector('[data-dropdown-selected]');
    const list = dropdown.querySelector('[data-dropdown-list]');
    const options = dropdown.querySelectorAll('.custom-variant-dropdown__option');
    const wrapper = dropdown.closest('.custom-variant-dropdown-wrapper');
    const select = wrapper.querySelector('select');

    // Open/close dropdown
    dropdown.addEventListener('click', function (e) {
      // Only toggle if not clicking an option button
      if (e.target.classList.contains('custom-variant-dropdown__option')) return;
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('open');
      closeAllDropdowns(dropdown);
      if (!isOpen) {
        list.removeAttribute('hidden');
        dropdown.classList.add('open');
      } else {
        list.setAttribute('hidden', '');
        dropdown.classList.remove('open');
      }
    });

    // Option selection
    options.forEach(function (optionBtn) {
      optionBtn.addEventListener('click', function (e) {
        e.preventDefault();
        const value = optionBtn.getAttribute('data-value');
        // Update visible selected
        selected.textContent = value;
        // Update visually hidden select
        select.value = value;
        // Update selected class
        options.forEach((btn) => btn.classList.remove('selected'));
        optionBtn.classList.add('selected');
        // Close dropdown
        list.setAttribute('hidden', '');
        dropdown.classList.remove('open');
        // Trigger change event for Shopify scripts
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Keyboard accessibility
    dropdown.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        list.setAttribute('hidden', '');
        dropdown.classList.remove('open');
        dropdown.blur();
      }
    });
  }

  // Setup all dropdowns on page load
  function initAllDropdowns() {
    document.querySelectorAll('.custom-variant-dropdown').forEach(function (dropdown) {
      // Prevent double-initialization
      if (!dropdown.hasAttribute('data-dropdown-initialized')) {
        setupDropdown(dropdown);
        dropdown.setAttribute('data-dropdown-initialized', 'true');
      }
    });
  }
  initAllDropdowns();

  // Close dropdown on outside click
  document.addEventListener('click', function (e) {
    closeAllDropdowns();
  });

  // Observe DOM changes to re-initialize dropdowns if needed
  const observer = new MutationObserver(function (mutationsList) {
    let needsInit = false;
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Only initialize dropdowns that are not already initialized
        needsInit = true;
        break;
      }
    }
    if (needsInit) {
      initAllDropdowns();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
